import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TicketStatus } from '@sb-tools/typescript/enums/ticket-status.enum';

@Pipe({
    name: 'ticketStatus',
})
export class TicketStatusPipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(ticketStatus: TicketStatus): string {
        switch (ticketStatus) {
            case TicketStatus.open:
                return this.translateService.instant('Open');
            case TicketStatus.pending:
                return this.translateService.instant('Pending');
            case TicketStatus.completed:
                return this.translateService.instant('Closed');
        }
    }
}
